import PalletPlantDetailsHeader from './PalletPlantDetailsHeader'
import PalletPlantDetailsList from './PalletPlantDetailsList'

export default function PalletPlantDetails(props){
    //console.debug("RTS Break PalletPlantDetails");

    return (
        <>
        <PalletPlantDetailsHeader data={props.plantData} />
        <PalletPlantDetailsList data={props.actionData} />
        </>
    );
}
